export const FILL_TYPE_LINEAR_GRADIENT = 'linear';
export const FILL_TYPE_RADIAL_GRADIENT = 'radial';
export const FILL_TYPE_ANGULAR_GRADIENT = 'angular';
export const FILL_TYPE_IMAGE = 'image';

export const SPREAD_METHOD_PAD = 'pad';
export const SPREAD_METHOD_REFLECT = 'reflect';
export const SPREAD_METHOD_REPEAT = 'repeat';
